import { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Check, Trash, Plus } from "@phosphor-icons/react";

export default function FollowUps() {
  const [items, setItems] = useState([]);
  const [form, setForm] = useState({ title: "", due_date: "", person_name: "", notes: "" });

  const load = () => api.get("/followups").then(r => setItems(r.data));
  useEffect(() => { load(); }, []);

  const add = async (e) => {
    e.preventDefault();
    if (!form.title) return;
    await api.post("/followups", form);
    setForm({ title: "", due_date: "", person_name: "", notes: "" });
    toast.success("Follow-up added");
    load();
  };
  const mark = async (id, status) => { await api.put(`/followups/${id}`, { status }); load(); };
  const del = async (id) => { await api.delete(`/followups/${id}`); load(); };

  const inp = "rounded-xl border border-slate-200 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-teal-400";

  return (
    <div data-testid="followups-page" className="space-y-6">
      <header>
        <div className="text-xs font-semibold uppercase tracking-[0.18em] text-slate-500">Follow-ups</div>
        <h1 className="text-3xl md:text-4xl font-semibold tracking-tight">Never drop a thread</h1>
      </header>

      <form onSubmit={add} className="bg-white border border-slate-200/70 rounded-2xl p-5 grid md:grid-cols-4 gap-3">
        <input data-testid="fu-title" required placeholder="Title" value={form.title} onChange={e=>setForm({...form, title: e.target.value})} className={`${inp} md:col-span-2`}/>
        <input data-testid="fu-due" type="date" value={form.due_date} onChange={e=>setForm({...form, due_date: e.target.value})} className={inp}/>
        <input data-testid="fu-person" placeholder="Person" value={form.person_name} onChange={e=>setForm({...form, person_name: e.target.value})} className={inp}/>
        <input data-testid="fu-notes" placeholder="Notes" value={form.notes} onChange={e=>setForm({...form, notes: e.target.value})} className={`${inp} md:col-span-3`}/>
        <button data-testid="fu-add" className="al-gradient text-white rounded-full py-2 font-medium"><Plus size={14} className="inline mr-1"/>Add</button>
      </form>

      <div className="bg-white border border-slate-200/70 rounded-2xl divide-y divide-slate-100">
        {items.length === 0 && <div className="p-6 text-slate-400 text-sm">No follow-ups yet.</div>}
        {items.map(f => (
          <div key={f.id} className="p-4 flex items-center gap-3">
            <button data-testid={`fu-toggle-${f.id}`} onClick={()=>mark(f.id, f.status === "done" ? "open" : "done")} className={`w-6 h-6 rounded-full border ${f.status === "done" ? "al-gradient border-transparent text-white" : "border-slate-300"} flex items-center justify-center`}>
              {f.status === "done" && <Check size={14} weight="bold"/>}
            </button>
            <div className="flex-1 min-w-0">
              <div className={`font-medium ${f.status === "done" ? "line-through text-slate-400" : ""}`}>{f.title}</div>
              <div className="text-xs text-slate-500">{f.due_date || "no date"}{f.person_name ? ` · ${f.person_name}` : ""}{f.notes ? ` · ${f.notes}` : ""}</div>
            </div>
            <button data-testid={`fu-del-${f.id}`} onClick={()=>del(f.id)} className="text-slate-400 hover:text-red-500"><Trash size={16}/></button>
          </div>
        ))}
      </div>
    </div>
  );
}
